import { WINDOW } from "constants/environment"
import React, { Component } from "react"
import Radium, { keyframes } from "higher-order-components/configured-radium/"
import PropTypes from "prop-types"
import { invokeFuncs } from "utils/function"
import COLOR_PALETTE from "constants/color-palette"
import { AnimatedCheckIcon } from "containers"

const themeLight = {
  message: valid => ({
    color: valid ? "#101010" : "#910A2D"
  })
}

const themeDark = {
  message: valid => ({
    color: valid ? "#fff" : "#910A2D"
  })
}

const themes = {
  dark: themeDark,
  light: themeLight
}

class CheckBox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      focused: false
    }
    this.onBlur = e => this.setState({ focused: false })
    this.onFocus = e => this.setState({ focused: true })
    this.handleClick = (e) => {
      const {
        value, checked, onClick, onChange, gtmEvents = false
      } = this.props
      const initValue = !!(checked || value);
      (onClick && onClick(e)) ||
        (onChange &&
          onChange({
            target: {
              value: !initValue
            }
          }))
      WINDOW && WINDOW.dispatchEvent(new CustomEvent("check"))
      if (gtmEvents) {
        initValue ? invokeFuncs(gtmEvents.unchecked) : invokeFuncs(gtmEvents.checked)
      }
    }
  }
  render() {
    const {
      label,
      value,
      checked,
      required,
      style = {},
      showBox = true,
      styleName = "light",
      message,
      isValid
    } = this.props
    const renderValue = !!(checked || value)
    const themeStyles = themes[styleName]
    return (
      <div style={[styles.checkbox, { ...style }]} data-test={"check-box"}>
        {showBox &&
        <div
          style={styles.checkboxInner(renderValue, this.state)}
          data-test={"check-box-" + (this.props.id || (typeof label !== "object" && label) || "checkbox")}
          onClick={this.handleClick}>
          <input
            type="checkbox"
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            value={renderValue}
            style={styles.input} />
          {renderValue && <AnimatedCheckIcon />}
        </div>}
        {label &&
          <label
            style={styles.label(styleName)}
            onClick={this.handleClick}>
            {label}
            {required &&
            <sup style={styles.sup}>*</sup>}
          </label>}
        {message &&
        <p style={[
          styles.message,
          themeStyles.message(isValid),
          styles.fadeIn]}>
          {message}
        </p>}
      </div>)
  }
}

CheckBox.propTypes = {
  label: PropTypes.node,
  value: PropTypes.bool,
  message: PropTypes.string,
  style: PropTypes.object,
  required: PropTypes.bool,
  showBox: PropTypes.bool,
  isValid: PropTypes.bool,
  checked: PropTypes.bool,
  styleName: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  gtmEvents: PropTypes.shape({
    checked: PropTypes.array,
    unchecked: PropTypes.array,
    clicked: PropTypes.array
  })
}


export default Radium(CheckBox)

const fadeInKeyframes = keyframes({
  from: {
    opacity: 0
  }
})

const styles = {
  message: {
    position: "absolute",
    left: "3em",
    fontSize: "75%",
    fontWeight: 200,
    top: "calc(100% + .1em)",
    margin: 0
  },
  checkbox: {
    position: "relative",
    display: "inline-block",
    whiteSpace: "noWrap",
    userSelect: "none",
    margin: ".5em 1em .5em 0"
  },
  label: styleName => ({
    marginLeft: "1em",
    display: "inline-block",
    verticalAlign: "top",
    whiteSpace: "normal",
    color: styleName === "dark" ? "#ffffff" : "#999999",
    fontSize: "90%",
    fontWeight: "200",
    lineHeight: 1.4,
    ":hover": {}
  }),
  input: {
    position: "absolute",
    cursor: "pointer",
    left: "10em",
    top: "10em",
    width: 0,
    height: 0
  },
  sup: {
    color: "#bf0000",
    fontWeight: "300",
    lineHeight: 1
  },
  fadeIn: {
    animation: "x .666s",
    animationName: fadeInKeyframes
  },
  checkboxInner: (renderValue, state) => ({
    borderRadius: "2px",
    position: "relative",
    display: "inline-block",
    cursor: "pointer",
    backgroundColor: renderValue ? "#910A2D" : "white",
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: state.focused
      ? "#82befb"
      : renderValue
        ? "#910A2D"
        : COLOR_PALETTE.GRAY_DARK,
    width: "0.75em",
    height: "0.75em",
    transition: "all 0.2s ease-in",
    padding: "0.1em",
    userSelect: "none",
    overflow: "hidden",
    verticalAlign: "top"
  })
}



// WEBPACK FOOTER //
// ./src/components/form-elements/checkbox/index.jsx